import { Injectable } from '@angular/core';
import { BaseClass } from './base-class';
@Injectable()
export abstract class BaseComponent extends BaseClass {
    constructor() {
        super();
    }
}
